var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1212 0.00046949H1.76187C1.03845 0.00046949 0.400024 0.586603 0.400024 1.34017V16.6605C0.400024 17.4137 1.03822 18.0002 1.76187 18.0002C1.84685 18.0002 1.97468 18.0002 2.05989 17.9583C6.31493 16.9537 12.9952 16.3259 20.5266 16.3259C27.9305 16.3259 34.4834 16.9535 38.781 17.9166C38.8663 17.9583 38.9936 17.9583 39.0788 17.9583C39.8025 17.9583 40.3979 17.3724 40.3979 16.6186V1.33949C40.4407 0.627842 39.8451 0.000244141 39.1215 0.000244141L39.1212 0.00046949ZM39.1212 1.33995V16.5769C34.5682 15.5721 27.8453 14.986 20.5693 14.986C13.1651 14.986 6.3147 15.6138 1.76164 16.6603V1.33972H39.1212V1.33995Z",
    className: "color3Fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 26.8003H9.47572V25.1626C9.47572 23.9341 8.44126 22.9103 7.20009 22.9103C5.95869 22.9103 4.92423 23.9341 4.92423 25.1626V26.8003H3.59998V25.1626C3.59998 23.1971 5.21381 21.6003 7.19964 21.6003C9.18569 21.6003 10.7993 23.1971 10.7993 25.1626L10.8 26.8003Z",
    className: "color3Fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 26.8003H18.2759V25.1626C18.2759 23.9341 17.2413 22.9103 15.9998 22.9103C14.7583 22.9103 13.7237 23.9341 13.7237 25.1626V26.8003H12.4V25.1626C12.4 23.1971 14.014 21.6003 16 21.6003C17.9863 21.6003 19.6 23.1971 19.6 25.1626V26.8003Z",
    className: "color3Fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4 26.8003H27.0759V25.1626C27.0759 23.9341 26.0414 22.9103 24.8 22.9103C23.5585 22.9103 22.524 23.9341 22.524 25.1626V26.8003H21.2V25.1626C21.2 23.1971 22.8136 21.6003 24.7997 21.6003C26.7856 21.6003 28.3995 23.1971 28.3995 25.1626L28.4 26.8003Z",
    className: "color3Fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2 26.8003H35.8757V25.1626C35.8757 23.9341 34.8413 22.9103 33.5999 22.9103C32.3587 22.9103 31.3243 23.9341 31.3243 25.1626V26.8003H30V25.1626C30 23.1971 31.6136 21.6003 33.5997 21.6003C35.5857 21.6003 37.1993 23.1971 37.1993 25.1626L37.2 26.8003Z",
    className: "color3Fill"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_3752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.0002H40.8V0.000244141H0V30.0002Z",
    className: "basecolor3Fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_3752)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 29.6002H40.8V28.4002H0V29.6002Z",
    className: "color3Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2649 4.40027L23.2 5.3354L17.7354 10.8003L16.8 9.86513L22.2649 4.40027Z",
    className: "color3Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0736 7.60022L24 8.5265L20.5263 12.0002L19.6 11.0739L23.0736 7.60022Z",
    className: "color3Fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreen);
export default __webpack_public_path__ + "static/media/iconScreen.51972b86eed655b1bcf1b2dc832c3b83.svg";
export { ForwardRef as ReactComponent };